// UI-side Role gating. The backend decides what each Role may do and serves it
// from GET /api/v1/me; AuthContext stores it on the user as `tabs` and
// `manageableRoles`. These helpers only read it. The backend is the real gate.
export const ROLES = ['owner', 'admin', 'hr', 'user']; // highest level first

// Role from the token's groups, used until /me answers.
export function roleFromGroups(groups = []) {
  return ROLES.find(role => groups.includes(role)) || 'user';
}

export function canSeeTab(user, tab) {
  return user?.tabs?.includes(tab) ?? false;
}

export function hasDashboard(user) {
  return (user?.tabs?.length ?? 0) > 0;
}

// Roles the user may act on and assign, lowest level first.
export function manageableRoles(user) {
  return user?.manageableRoles ?? [];
}
